import { Box, useColorModeValue } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export default function ContentContainerBox({ children }: PropsWithChildren) {
  const color = useColorModeValue("#F9F9F9", "chakra-subtle-bg");

  return (
    <Box w="100%" p="16px" borderRadius="md" bg={color}>
      {children}
    </Box>
  );
}

